module.exports = __webpack_public_path__ + "img/c87d660.webp";